<h1 mat-dialog-title>Enter Preset Message:</h1>
<mat-dialog-content>
  <mat-form-field class="full-width" appearance="fill">
    <textarea matInput placeholder="" [(ngModel)]="message"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="onNoClick(message);" [disabled]="!validateMessage(message)" >Confirm</button>
  <button mat-raised-button (click)="onNoClick('');">Cancel</button>
</mat-dialog-actions>
